export default {

    // меню
    'Заявки': 'Đơn đăng ký',
    Заказы: 'Đơn đặt hàng',
    'Новый заказ': 'Đơn đặt hàng mới',
    'Билеты в музеи': 'Vé tham quan bảo tàng',
    'Подать график': 'Nộp (thông báo) lịch trình làm việc',
    'Радио/Аудиогид': 'Radio / AudioGuide',
    Архив: 'Lưu trữ',
    Отчеты: 'Tổng kết',
    Сверка: 'Kiểm tra',
    Оплата: 'Thanh toán ',
    'Оплата Wechat': 'Thanh toán qua ứng dụng WeChat',
    'Оплата заявок': 'Thanh toán đơn đặt hàng',
    'История платежей': 'Lịch sử chi trả',
    'Прайс-лист': 'Đơn giá',
    'Продление лицензий': 'Gia hạn giấy phép hướng dẫn',
    'Мои лицензии': 'Giấy phép hướng dẫn  của tôi',
    Продление: 'Gia hạn',
    Информация: 'Thông tin',
    Новости: 'Tin mới / thời sự',
    Транспорт: 'Phương tiện vận chuyển',
    'О компании': 'Thông tin về công ty',
    Договор: 'Hợp đồng',
    'Договор оферты': 'Hợp đồng ưu đãi',
    'Политика возврата': 'Chính sách hoàn trả',
    'Поиск по ref, номеру заявки, дате или объекту': 'Tìm kiếm theo số định danh, theo đơn đặt hàng, theo ngày hoặc theo tên bảo tàng',
    Настройки: 'Cài đặt',
    Помощь: 'Trợ giúp',
    'Обратная связь': 'Liên hệ',
    Выйти: 'Thoát ra',
    'Старая версия сайта': 'Phiên bản cũ của trang web',
    'ООО «АВАНГАРД ТРАВЕЛ ГРУПП»': 'Công ty trách nhiệm hữu hạn Avangard Travel Group',

    // заказы
    'Нет предстоящих заказов': 'Không có đơn hàng sắp tới',
    'Выберите форму заказа': 'Lựa chọn hình thức đặt hàng',
    'Заказать билеты в музей': 'Đặt vé tham quan bảo tàng',
    'Заказать Радио/Аудиогиды': 'Đặt Radio / Đặt AudioGuide',
    Заявка: 'Đơn hàng',
    'В обработке': 'Đang trong quá trình xử lý',
    'Подтврждена': 'Khẳng định / xác nhận',
    'Лист ожидания': 'Danh sách chờ',
    'Аннулирована': 'Đã được hủy bỏ',
    'Отклонена': 'Đã bị từ chối',
    'Подтвержденное время:': 'Thời gian đã được xác nhận',
    'Вход': 'Lối vào / cổng vào',
    'ПОДРОБНЕЕ': 'Tìm hiểu thêm chi tiết',
    'ИЗМЕНИТЬ': 'Thay đổi',
    'ГДЕ СОТРУДНИК': 'Đồng nghiệp ở đâu',
    'АННУЛИРОВАТЬ': 'Hủy bỏ',
    'В АРХИВ': 'Trong kho lưu trữ',
    'Сотрудник на объекте': 'Đồng nghiệp đang có mặt tại địa điểm',
    'Сотрудник не на объекте': 'Đồng nghiệp không có mặt tại địa điểm',
    'Но вы можете связаться с нами:': 'Nhưng bạn có thể liên hệ với chúng tôi',
    'Аннулировать': 'Hủy bỏ',
    'Хотите аннулировать заявку?': 'Bạn muốn hủy bỏ đơn đăng ký',
    'Аннулированная заявка попадет в архив и восстановить ее будет невозможно': 'Đơn đăng ký hủy chuyển vào vùng Lưu trữ và không có khả năng khôi phục lại',
    'Отмена': 'Hủy bỏ',
    'Дата и время:': 'Ngày tháng và thời gian',
    'Имя гида:': 'Họ tên hướng dẫn viên',
    'Не заполнено': 'Không điền vào đủ',
    'Телефон гида:': 'Điện thoại hướng dẫn viên',
    'Пожелания:': 'Mong muốn (ghi chú)',
    'Подтвержденное время и вход:': 'Xác nhận thời gian và cổng vào',
    'Билеты:': 'Vé ',
    'Дополнительные услуги:': 'Dịch vụ bổ sung',
    'Причина отклонения:': 'Nguyên nhân bị từ chối',
    'Информация о группе:': 'Thông tin về đoàn khách (nhóm)',
    'Доп.услуги:': 'Dịch vụ bổ sung',
    'Доп.информация:': 'Thông tin bổ sung',
    'График': 'Lịch làm việc',
    'Гид': 'Hướng dẫn viên',
    'Заказать': 'Đặt hàng',

    // новый заказ
    'Информация о музее': 'Thông tin về bảo tàng',
    'Выберите категорию группы (РФ или ИГ), музей, дату и время': 'Lựa chọn danh mục khách hàng (công dân Nga hay khách nước ngoài), Bảo tàng, ngày tháng và thời gian',
    'Выберите категорию группы': 'Lựa chọn danh mục khách hàng ',
    'Выберите музей': 'Lựa chọn bảo tàng',
    'Выберите объект': 'Lựa chọn địa điểm',
    Далее: 'Tiếp tục',
    'Выберите дату': 'Lựa chọn ngày tháng',
    'Выберите время': 'Lựa chọn thời gian',
    'Информация о группе': 'Thông tin về nhóm khách ',
    'Выберите кол-во билетов': 'Lựa chọn số lượng vé ',
    'Выберите страну': 'Lựa chọn quốc gia',
    Назад: 'Về trang trước (Quay lại trang trước)',
    'Доп. услуги': 'Dịch vụ bổ sung',
    'Выберите дополнительные услуги': 'Lựa chọn dịch vụ bổ sung',
    'Кол-во гидов сопровождающих (если нет лицензии)': 'Số lượng hướng dẫn viên cần đặt (nếu không có hướng dẫn viên có giấy phép)',
    'Необходим если у гида нет лицензии в выбранный музей': 'Cần đặt nếu đoàn không có hướng dẫn viên có giấy phép làm việc trong bảo tàng này',
    'Доп. информация': 'Thông tin bổ sung',
    'Информация о гиде и пожелания': 'Thông tin về hướng dẫn viên và mong muốn',
    'Ref номер (необязательно)': 'Số định danh (không bắt buộc)',
    'Уникальный номер группы / вспомогательный номер для ваших целей': 'Mã số của đoàn / Số phụ trợ dành cho mục đích của bạn',
    'Имя гида': 'Họ tên hướng dẫn viên',
    'Телефон гида': 'Số điện thoại hướng dẫn viên',
    Пожелания: 'Mong muốn (ghi chú)',
    'В поле "Пожелания" укажите:': 'Trong mục "Mong muốn (ghi chú)" ghi rõ',
    'адрес и время получения': 'Địa chỉ và thời gian nhận ',
    'адрес и приблизительное время возврата оборудования': 'Địa chỉ và thời gian giao trả lại thiết bị',
    Отправить: 'Gửi đi',
    'Пожалуйста, ожидайте': 'Xin vui lòng chờ',
    'Успешно!': 'Thành công',
    'Заказ создан': 'Đơn hàng đã tạo xong',
    'Ошибка:': 'Lỗi',
    Ок: 'OK',
    'Кол-во взрослых': 'Số lượng người lớn',
    'Кол-во детей': 'Số lượng trẻ em',
    'итого:': 'Tổng số',
    'чел. (надо': 'Số lượng khách',
    'экскурс.обсл.)': 'Dịch vụ tham quan',
    'гид. или сопровожд.)': 'Hướng dẫn viên hoặc nhân viên đi kèm',
    'Радиогид': 'RadioGuide',
    'Экскурсия ведется лицензионным гидом': 'Chương trình tham quan được hướng dẫn bởi hướng dẫn viên có giấy phép hợp lệ',
    'Аудиогид': 'AudioGuide',
    'Экскурсия ведется при помощи технических средств на языке группы': 'Chương trình tham quan được hướng dẫn bởi thiết bị điện tử bằng ngôn ngữ của đoàn',
    'Кол-во гидов с лицензией': 'Số lượng hướng dẫn viên có giấy phép hành nghề',
    'Кол-во сопровождающих': 'Số lượng nhân viên đi kèm',
    'Удалить': 'Hủy bỏ',
    'Отправить заказ': 'Gửi đơn đặt hàng',
    'Добавить группу': 'Thêm đoàn khách',
    'Группа': 'Đoàn khách',

    // архив
    'Номер заявки или ref': 'Mã số đơn đăng ký hoặc mã số định danh',
    Объект: 'Địa điểm',
    'Номер заявки': 'Mã số đơn đăng ký',
    Все: 'Tất cả',
    'Дата посещения с': 'Ngày tham quan từ',
    'Дата посещения по': 'Ngày tham quan đến',
    Найти: 'Tìm kiếm',
    'Заказов согласно фильтру не найдено': 'Đơn đặt hàng theo bộ lọc không được tìm thấy',
    Ошибка: 'Lỗi',
    'Любой номер': 'Số bất kỳ',

    // сверка
    Сформировать: 'Tạo lập',
    'Файл сверки': 'File kiểm tra',
    'Для скачивания сформированного файла сверки нажмите на конпку "Скачать".': 'Để tải file "Kiểm tra" hãy nhấn nút "Tải về"',
    'Скачать': 'Tải về',

    // оплата заявок
    'Оплатить заявки': 'Thanh toán đơn đăng ký',
    'Номера ваучеров или заявок для оплаты (через запятую)': 'Số voucher hoặc mã số đơn đăng ký (cách dấu phẩy)',
    'Введите номера ваучеров или заявок для оплаты': 'Điền số voucher hoặc mã số đơn đăng ký để thanh toán',
    'ФИО или название организации': 'Họ tên hoặc tên công ty',
    'Введите ФИО или название организации': 'Điền họ tên hoặc tên công ty',
    Email: 'Email',
    'Введите Email': 'Điền địa chỉ email',
    'Сумма к оплате': 'Tổng số tiền cần thanh toán',
    'Введите сумму к оплате': 'Điền tổng số tiền cần thanh toán',
    'Согласен с договором оферты': 'Theo hợp đồng đề nghị',
    'Перейти к оплате': 'Tiến hành thanh toán',
    'Подождите,': 'Xin vui lòng chờ,',
    'принимаем': 'Chấp nhận thanh toán',
    'оплату...': 'Thanh toán...',
    'Заказ успешно оплачен!': 'Đơn đặt hàng đã thanh toán thành công',
    'Ваш заказ': 'Đơn đặt hàng của bạn',
    'успешно оплачен. Спасибо за покупку!': 'Thanh toán thành công. Cảm ơn vì đã mua hàng!',
    'Что-то пошло не так!': 'Đã xảy ra lỗi!',
    'При оплате заказа': 'Trong quá trình thanh toán đơn hàng',
    'произошла ошибка!': 'Đã xảy ra lỗi',
    'Cчет успешно сформирован!': 'Hóa đơn đã được tạo lập ',
    'Вы можете открыть его нажав кнопку ниже': 'Bạn có thể mở hóa đơn khi nhấn nút ở phía dưới',
    'Открыть счет': 'Hóa đơn đã được mở',
    'Физическим лицам': 'Khách hàng cá nhân',
    'Юридическим лицам': 'Khách hàng pháp nhân công ty',
    'Для формирования счета на оплату введите номера ваучеров или заказов, укажите реквизиты компании и точную сумму:': 'Để tạo lập hóa đơn thanh toán, hãy điền số Voucher hoặc số đơn đặt hàng,hãy điền thông ty công ty và tổng tiền thanh toán ',
    'Для оплаты введите номера ваучеров или заявок и укажите точную сумму для оплаты:': 'Để trả tiền, hãy điền số Voucher hoặc mã số đơn đăng ký, hãy điền tổng tiền cần chi trả',
    'Название организации': 'Tên công ty',
    'Юридический адрес': 'Địa chỉ pháp nhân công ty',
    'Сформировать счет': 'Tạo lập hóa đơn',
    'Расчетный счет': 'Tài khoản thanh toán của công ty',
    'ИНН': 'Mã số thuế công ty',
    'КПП': 'KPP',
    'Банк': 'Ngân hàng',
    'Полное название банка (для формирования акта). Например: ': 'Tên ngân hàng (để thanh lý đơn đặt hàng). Ví dụ:',
    'БИК Банка': 'BIK của ngân hàng',
    'Корреспондентский счет': 'Tài khoản trung chuyển của ngân hàng',

    // история платежей
    'Номер платежа': 'Số thanh toán',
    Ваучеры: 'Chứng từ',
    'Способ оплаты': 'Hình thức chi trả',
    'Время и дата оплаты': 'Thời gian và ngày tháng chi trả',
    Сумма: 'Tổng số',
    Статус: 'Trạng thái (tình trạng)',
    'Платежи отсутствуют': 'Không có các thanh toán ',

    // прайс-лист
    'Прайс-лист для иностранных групп': 'Danh sách đơn giá dành cho đoàn khách nước ngoài',
    'Актуальный файл с ценами для иностранных групп.': 'File "Đơn giá hiện tại dành cho đoàn khách nước ngoài"',
    Открыть: 'Mở',
    'Прайс-лист для российских групп': 'Danh sách đơn giá dành cho đoàn khách Nga',
    'Актуальный файл с ценами для российских групп.': 'File "Đơn giá hiện tại dành cho đoàn khách Nga"',

    // лицензии
    'Добавить лицензию': 'Thêm giấp phép',
    'В настоящий момент нет сохраненных лицензий, вы можете добавить их.': 'Hiện tại không có dữ liệu về giấy phép trong lưu trữ, bạn có thể thêm vào',
    'Добавить': 'Thêm',
    'Музей': 'Bảo tàng',
    'Номер лицензии': 'Số giấy phép',
    'Стаж (лет)': 'Kinh nghiệm (năm)',
    'Дата окончания': 'Ngày kết thúc',
    'Основной язык': 'Ngôn ngữ chính',
    'Дополнительные языки': 'Ngôn ngữ phụ',

    // о компании
    'ИНН:7841027155': 'Mã số thuế INN:7841027155',
    'КПП: 784101001': 'KPP: 784101001',
    'ОГРН: 1157847276003': 'OGRN: 1157847276003',
    'ОКПО: 25885413': 'OKPO: 25885413',
    'Расчетный счет: 40702810603260000188': 'Tài khoản giao dịch: 40702810603260000188',
    'Банк: Филиал "Центральный" Банка ВТБ (ПАО)': 'Ngân hàng: Chi nhánh Trung tâm, Ngân hàng ngoại thương VTB / Филиал "Центральный" Банка ВТБ (ПАО)',
    'БИК: 044525411': 'BIK: 044525411',
    'Корр. счет: 30101810145250000411': 'Tài khoản trung chuyển: 30101810145250000411',
    'Юридический адрес: 191186, Санкт-Петербург г, вн.тер. г. муниципальный округ Дворцовый округ, наб Канала Грибоедова, д. 5, литера Е, помещ. Ч.ПОМ. 19-Н ОФ.405': 'Địa chỉ công ty: 191186, Russia, Saint-Petersburg, nabereznaya Kanala Griboedova, nhà số 5, LIT.E, mặt bằng 19-H, văn phòng 405',
    'Email: info@avangard-travel.ru': 'Email: info@avangard-travel.ru',
    'Телефон: (812) 640-02-28': 'Điện thoại: +7(812) 640-02-28',

    // договор
    'Вы можете посмотреть договор с ООО "Авангард Травел Групп".': 'Bạn có thểm xem mẫu hợp đồng của công ty trách nhiệm hữu hạn "Avangard Travel Group"',

    // договор оферты
    'Вы можете посмотреть договор оферты с ООО "Авангард Травел Групп".': 'Bạn có thểm xem hợp đồng ưu đãi của công ty trách nhiệm hữu hạn "Avangard Travel Group"',

    // политика возврата
    'Вы можете посмотреть политику возврата.': 'Bạn có thểm xem các chính sách hoàn trả',

    // настройки
    'Имя:': 'Họ tên',
    'Телефон:': 'Số điện thoại',
    'Страна:': 'Quốc gia',
    'Информация о гиде': 'Thông tin về hướng dẫn viên',
    'Заполните информацию и подавайте заявки еще быстрее': 'Hãy điền thêm thông tin để gửi đơn đăng ký nhanh hơn',
    Имя: 'Họ tên',
    Телефон: 'Số điện thoại',
    'Выберите страницу': 'Hãy lựa chọn quốc gia',
    'Использовать в заказе?': 'Sử dụng trong đơn đặt hàng',
    Сохранить: 'Lưu giữ',
    'Являетесь ли вы туристической фирмой / юридическим лицом': 'Bạn là công ty du lịch / hoặc pháp nhân công ty',
    'Юридическое лицо': 'Pháp nhân công ty',
    'Для выставления счетов': 'Dùng để tạo lập hóa đơn thanh toán',

    // форма логина
    Логин: 'Tên đăng nhập',
    Пароль: 'Mật khẩu',
    Войти: 'Đăng nhập vào tài khoản',
    'Выберите язык': 'Hãy chọn ngôn ngũ',
    'У вас нет аккаунта?': 'Bạn chưa có tài khoản?',
    'Зарегистрироваться': 'Đăng ký',
    'Добро пожаловать!': 'Chào mừng bạn!',
    'Будем рады видеть вас среди наших клиентов! Пожалуйста, уделите немного времени на заполнение формы ниже. Вскоре мы отправим вам все необходимые инструкции на указанный адрес электронной почты.': 'Chúng tôi rất vui mừng khi bạn trở thành khách hàng của chúng tôi! Hãy dành một chút thời gian để điền vào mẫu dưới đây. Chúng tôi sẽ gửi cho bạn các hướng dẫn cần thiết qua địa chỉ email của bạn.',
    'Фамилия': 'Họ',
    'Физ.лицо': 'Cá nhân',
    'Юр.лицо': 'Pháp nhân',
    'Отчество': 'Tên đệm',
    'У вас есть аккаунт?': 'Bạn đã có tài khoản?',
    'Название фирмы': 'Tên công ty',
    'БИК': 'BIK',
    'ФИО контактного лица': 'Họ tên người liên hệ',
    'Заявка принята!': 'Đơn đăng ký đã được ghi nhận!',
    'Спасибо за вашу заявку! В ближайшее время на указанный вами адрес электронной почты мы отправим все необходимые инструкции.': 'Cảm ơn vì đã gửi đơn đăng ký! Chúng tôi sẽ gửi cho bạn các hướng dẫn cần thiết qua địa chỉ email của bạn.',
    'Закрыть': 'Đóng',

    // уведомление
    'Теперь можно оплатить заявки онлайн, включая оплату от юридических лиц!': 'Hiện tại bạn có thể thanh toán trực tuyến, kể cả thanh toán dành cho các pháp nhân công ty',
    'Мы рады сообщить, что теперь вы можете оплатить заявки на нашем сайте, используя банковскую карту или QR-код системы быстрых платежей. Вдобавок к этому, мы расширили наши возможности и теперь доступна оплата и для юридических лиц. Юридические лица могут самостоятельно генерировать счета для оплаты.': 'Chúng tôi hân hạnh thông báo: Hiện tại bạn có thể thanh toán trực tuyến trên trang web của chúng tôi bằng thẻ ngân hàng hoặc qua mã QR trong hệ thống thanh toán nhanh SBP. Hình thức thanh toán này áp dụng cho khách hàng cá nhân và cho cả các pháp nhân công ty. Các hóa đơn sẽ được tự động tạo ra khi các pháp nhân công ty  tiến hành thanh toán trực tuyến trên trang web của chúng tôi.',
    'Никаких задержек и лишних хлопот - оплата проходит мгновенно. Перейдите в раздел "Оплата заявок" и оплачивайте свои заявки быстро и удобно! Наши новые возможности сделают процесс ещё более удобным и эффективным.': 'Bạn sẽ không phải chờ đợi hoặc làm các thao tác mất thời gian khác - thanh toán sẽ được thực hiện ngay lập tức. Hãy chọn ấn nút "Thanh toán đơn hàng" và chi trả đơn hàng một cách nhanh chóng và thuận tiện. Những khả năng mới trong thanh toán của chúng tôi khiến quá trình đặt và thanh toán thuận tiện và hiệu quả.',

    // помощь
    'У вас есть вопросы?': 'Bạn có các câu hỏi?',
    'Если вы не можете найти ответ на вопрос, вы всегда можете связаться с нами. Мы ответим вам в ближайшее время!': 'Nếu bạn không thể tìm thấy giải đáp cho các câu hỏi, bạn luôn luôn có thể liên hệ với chúng tôi. Chúng tôi sẽ trả lời bạn trong thowifw gian ngắn nhất!',
    'Мы всегда рады помочь!': 'Chúng tôi luôn luôn sẵn lòng trợ giúp!',
    'Лучший способ получить ответ быстрее!': 'Cách tốt nhất để được giải đáp nhanh nhất!',

    // в разработе
    'Готовимся к запуску. Новая функция в пути! 🚀': 'Chuẩn bị khởi động. Tính năng mới đang được triển khai!',
    'Мы активно работаем над новой функцией для вас.': 'Chúng tôi tích cực phát triển những tính năng mới dành cho bạn!',
    'Будьте в курсе предстоящих обновлений!': 'Hãy chú ý đến những cập nhật mới!',

    // Обратная связь
    'Мы всегда рады услышать вас!': 'Chúng tôi luôn vui mừng nghe thấy bạn!',
    'Наши усилия направлены на то, чтобы сделать систему подачи заявок максимально удобной и эффективной для вас. Ваше мнение и предложения играют ключевую роль в этом процессе. Не стесняйтесь делиться своими мыслями, идеями, а также сообщать нам обо всех замеченных ошибках или проблемах в работе системы. Вместе мы сделаем систему подачи заявок лучше!': 'Những nổ lực của chúng tôi hướng đến việc tạo ra một hệ thống đăng ký đơn hàng thuận tiện và hiệu quả. Ý kiến và ý tưởng của bạn rất quan trọng với chúng tôi trong quá trình này. Xin vui lòng chia sẻ với chúng tôi những ý tưởng, kinh nghiệm và các vấn đề bất cập, các lỗi kỹ thuật mà bạn gặp phải trong quá trình làm việc ở hệ thống của chúng tôi. Hãy cùng nhau phát triển hệ thống tốt và hiệu quả hơn.',
    'Как к вам обращаться?': 'Làm thế nào để liên hệ với bạn?',
    'Email для обратной связи': 'Email để liên hệ',
    'Опишите ваше предложение, жалобу или замеченную ошибку': 'Hãy gửi những đề nghị, phàn nàn của bạn hoặc thông tin về lỗi kỹ thuật cho chúng tôi!',
    'Мы используем файлы cookie, чтобы сайт работал и был удобнее. Оставаясь на сайте, вы соглашаетесь на их использование.': 'Chúng tôi sử dụng cookie để trang web hoạt động và thuận tiện hơn. Khi tiếp tục sử dụng trang web, bạn đồng ý với việc sử dụng cookie.',
    'Хорошо': 'Đã hiểu',
    'Подача графика на {month} закрывается {deadline}.': 'Đăng ký lịch trình cho {month} sẽ đóng vào {deadline}.',
    'Россия': 'Nga',

    // оплата лицензий
    'Оплата продления': 'Thanh toán gia hạn',
    'Оплатить': 'Thanh toán',
    'К заказам': 'Về đơn hàng',
    'Повторить': 'Thử lại',
    'Выбор лицензий': 'Chọn giấy phép',
    'Выберите одну или несколько лицензий для оплаты': 'Chọn một hoặc nhiều giấy phép cần thanh toán',
    'Сезон продления: приём заявок с {start} по {finish}': 'Mùa gia hạn: nhận đơn từ {start} đến {finish}',
    'Выберите лицензии': 'Chọn giấy phép',
    'Нет лицензий для оплаты': 'Không có giấy phép nào để thanh toán',
    'Итого к оплате': 'Tổng thanh toán',
    'Плательщик': 'Người thanh toán',
    'ФИО и email, на который придёт чек': 'Họ tên và email nhận biên lai',
    'Проверьте список лицензий и перейдите к оплате': 'Kiểm tra danh sách giấy phép và chuyển sang thanh toán',
    'Лицензия № {no}': 'Giấy phép số {no}',
    'После оплаты менеджер получит уведомление и отметит оплату. Чек придёт на указанный email.': 'Sau khi thanh toán, quản lý sẽ nhận thông báo và ghi nhận khoản thanh toán. Biên lai sẽ được gửi tới email bạn đã nhập.',
    'Продление уже оплачено': 'Đã thanh toán gia hạn',
    'Оплачено на сайте, ждёт подтверждения менеджера': 'Đã thanh toán trên trang web, chờ quản lý xác nhận',
    'Оплата лицензий пока недоступна.': 'Thanh toán giấy phép hiện chưa khả dụng.',
    'Цены на лицензии ещё не опубликованы. Попробуйте позже или свяжитесь с менеджером.': 'Giá giấy phép chưa được công bố. Vui lòng thử lại sau hoặc liên hệ quản lý.',
    'Не удалось получить список лицензий. Попробуйте ещё раз.': 'Không tải được danh sách giấy phép. Vui lòng thử lại.',
    'Не удалось создать счёт на оплату. Попробуйте ещё раз.': 'Không tạo được hóa đơn thanh toán. Vui lòng thử lại.',
    'Список лицензий или цены изменились. Обновите страницу и выберите лицензии заново.': 'Danh sách giấy phép hoặc giá đã thay đổi. Hãy tải lại trang và chọn lại giấy phép.',
    'Введите email': 'Nhập email',
    'Введите ваш email': 'Nhập email của bạn',
    'Продление этой лицензии сейчас закрыто': 'Hiện chưa mở gia hạn cho giấy phép này',
    'Укажите язык лицензии в разделе «Мои лицензии»': 'Hãy chọn ngôn ngữ của giấy phép trong mục “Giấy phép của tôi”',
    'Заявка на продление подана': 'Đã nộp đơn gia hạn',
    'Заявка на продление будет подана автоматически': 'Đơn gia hạn sẽ được nộp tự động',
    'Заявку на продление оформит менеджер': 'Quản lý sẽ lập đơn gia hạn',
    'Добавьте свои лицензии в раздел «Мои лицензии», и заявки на продление будут подаваться автоматически.': 'Hãy thêm giấy phép vào mục “Giấy phép của tôi”, đơn gia hạn sẽ được nộp tự động.',
    'Консультационные услуги (лицензии)': 'Dịch vụ tư vấn (giấy phép)',
    'Продление или первичное получение, затем музей': 'Gia hạn hoặc cấp lần đầu, sau đó chọn bảo tàng',
    'Первичное получение': 'Cấp lần đầu',
    'первичное получение': 'cấp lần đầu',
    'Оплата в офисе': 'Thanh toán tại văn phòng',
    'Итого к оплате на сайте': 'Tổng thanh toán trực tuyến',
    'ФИО для договора, телефон и email, на который придёт чек': 'Họ tên cho hợp đồng, điện thoại và email nhận biên lai',
    'ФИО': 'Họ và tên',
    'Фамилия Имя Отчество': 'Họ, tên, tên đệm',
    'Введите ФИО полностью': 'Nhập đầy đủ họ tên',
    'Контактный телефон': 'Điện thoại liên hệ',
    'Введите корректный телефон': 'Nhập số điện thoại hợp lệ',
    'Договор и оплата': 'Hợp đồng và thanh toán',
    'Проверьте список, подтвердите договор и перейдите к оплате': 'Kiểm tra danh sách, xác nhận hợp đồng và chuyển sang thanh toán',
    'Заявки на продление поданы.': 'Đã nộp đơn gia hạn.',
    'Оплата этих лицензий производится в офисе. Для справок свяжитесь с менеджером по телефону {phone}.': 'Các giấy phép này được thanh toán tại văn phòng. Để biết thêm, hãy liên hệ quản lý theo số {phone}.',
    'Договор оказания услуг': 'Hợp đồng dịch vụ',
    'Не удалось получить текст договора. Попробуйте ещё раз.': 'Không tải được nội dung hợp đồng. Vui lòng thử lại.',
    'Я принимаю условия договора возмездного оказания услуг': 'Tôi chấp nhận các điều khoản của hợp đồng cung cấp dịch vụ có thu phí',
    'Подать заявки': 'Nộp đơn',
    'Выбор группы откроется после оплаты продления.': 'Chọn nhóm sẽ mở sau khi thanh toán gia hạn.',
    'Оплатить продление': 'Thanh toán gia hạn',
    'Продление оплачено на сайте.': 'Đã thanh toán gia hạn trên trang web.',
    'Не удалось записаться в группу. Попробуйте ещё раз.': 'Không thể ghi danh vào nhóm. Vui lòng thử lại.',
    'Выбрать группу': 'Chọn nhóm',
    'Теперь можно выбрать группу для занятий: она появится в карточке музея на странице «Продление», как только менеджер назначит даты.': 'Bây giờ bạn có thể chọn nhóm học: nhóm sẽ hiện trong thẻ bảo tàng ở trang “Gia hạn” ngay khi quản lý ấn định ngày.',
    'Тестовый режим': 'Chế độ thử nghiệm',
    'Раздел проверяется, оплачивать лицензии через сайт пока не нужно.': 'Mục này đang được thử nghiệm, hiện chưa cần thanh toán giấy phép qua trang web.',
    'истекла': 'đã hết hạn',
    'Не удалось удалить лицензию. Попробуйте ещё раз.': 'Không xóa được giấy phép. Vui lòng thử lại.',
    'Не удалось добавить лицензию. Попробуйте ещё раз.': 'Không thêm được giấy phép. Vui lòng thử lại.',
    'Расписание занятий': 'Lịch học',
    'Расписание занятий пока не опубликовано.': 'Lịch học chưa được công bố.',
    'Расписание занятий появится после записи.': 'Lịch học sẽ hiển thị sau khi đăng ký.',
    'Стоимость занятий': 'Học phí',
    'Записаться на продление': 'Đăng ký gia hạn',
    'Оплатить занятия': 'Thanh toán buổi học',
    'Выбрать дату занятий': 'Chọn ngày học',
    'Подать заявку на продление: {museum}? После этого станет видно расписание занятий.': 'Gửi yêu cầu gia hạn: {museum}? Sau đó lịch học sẽ hiển thị.',
    'Продление по этому музею сейчас закрыто.': 'Hiện không nhận gia hạn cho bảo tàng này.',
    'Укажите в лицензии язык: без него заявку не принять. Это можно сделать через «Изменить».': 'Vui lòng ghi ngôn ngữ trong giấy phép: thiếu thông tin này thì không thể nhận yêu cầu. Bạn có thể thực hiện qua «Изменить».',
    'Лицензия продлена.': 'Giấy phép đã được gia hạn.',
    'Заявка на продление подана.': 'Đã gửi yêu cầu gia hạn.',
    'Занятия оплачены.': 'Đã thanh toán buổi học.',
    'Занятия оплачены на сайте, менеджер подтвердит оплату.': 'Đã thanh toán buổi học trên trang web, quản lý sẽ xác nhận thanh toán.',
    'Вы записаны на занятия: {group}.': 'Bạn đã đăng ký buổi học: {group}.',
    'Не удалось подать заявку. Попробуйте ещё раз.': 'Không gửi được yêu cầu. Vui lòng thử lại.',
    'Занятия оплачены. Выберите дату занятий в карточке: {museums}.': 'Đã thanh toán buổi học. Hãy chọn ngày học trong thẻ: {museums}.',
    'Укажите язык лицензии на странице «Продление лицензий»': 'Hãy ghi ngôn ngữ của giấy phép trên trang «Gia hạn giấy phép hướng dẫn»',
    'Сначала добавьте лицензию на странице «Продление лицензий»': 'Trước tiên hãy thêm giấy phép trên trang «Gia hạn giấy phép»',
    'Оплата возвращена, можно оплатить заново': 'Đã hoàn tiền, bạn có thể thanh toán lại',
    'свободно {free} из {limit}': 'còn {free}/{limit} chỗ',
    'мест нет': 'hết chỗ',
    'Добавьте свои лицензии на странице «Продление лицензий», и заявки на продление будут подаваться автоматически.': 'Hãy thêm giấy phép của bạn trên trang «Gia hạn giấy phép hướng dẫn», yêu cầu gia hạn sẽ được gửi tự động.',
    'Теперь можно выбрать дату занятий по расписанию: откройте карточку лицензии на странице «Продление лицензий».': 'Bây giờ bạn có thể chọn ngày học theo lịch: hãy mở thẻ giấy phép trên trang «Gia hạn giấy phép hướng dẫn».',
    'Лицензии': 'Giấy phép',
    'Подать заявку': 'Gửi yêu cầu',
    'Выбрать': 'Chọn',
    'Стоимость пока не указана.': 'Chưa có giá.',
    'Лицензии на этот музей нет в кабинете. Добавьте её, чтобы записаться на продление и оплатить занятия.': 'Trong tài khoản chưa có giấy phép cho bảo tàng này. Hãy thêm giấy phép để đăng ký gia hạn và thanh toán buổi học.',
    'Музеи, где у вас нет лицензии': 'Bảo tàng bạn chưa có giấy phép',
    'С окончания срока действия лицензии прошло 3 года. Просьба обратиться к менеджеру за консультацией.': 'Đã tròn ba năm kể từ khi giấy phép hết hạn. Vui lòng liên hệ quản lý để được tư vấn.',
    'Прошло три года после окончания лицензии — нужно первичное обучение': 'Đã tròn ba năm kể từ khi giấy phép hết hạn — cần đào tạo lần đầu',
    'Просим вас вписать ФИО полностью и кириллицей: это нужно для соблюдения законодательства РФ.': 'Vui lòng ghi đầy đủ họ tên bằng chữ Kirin (chữ cái tiếng Nga): đây là yêu cầu của pháp luật Nga.',
    'Введите ФИО кириллицей — допустимы только буквы, пробел и дефис': 'Nhập họ tên bằng chữ Kirin (chữ cái tiếng Nga) — chỉ được dùng chữ cái, dấu cách và dấu gạch nối',
    'Оплатите занятия и после этого выберите дату и время.': 'Hãy thanh toán buổi học, sau đó chọn ngày và giờ.',
    'Выбрать дату и время занятий можно будет после подтверждения менеджера.': 'Bạn có thể chọn ngày và giờ học sau khi quản lý xác nhận.',
    'Поиск по лицензиям': 'Tìm giấy phép',
    'Музей или номер лицензии': 'Bảo tàng hoặc số giấy phép',
    'Ничего не найдено': 'Không tìm thấy gì',
    'Договоры оказания услуг': 'Các hợp đồng dịch vụ',
    'Договор на продление': 'Hợp đồng gia hạn',
    'Договор на первичное обучение': 'Hợp đồng đào tạo lần đầu',
    'Я принимаю условия договоров возмездного оказания услуг': 'Tôi chấp nhận các điều khoản của các hợp đồng cung cấp dịch vụ có thu phí',
    'Email:': 'Email',
    'После оплаты договор сохранится в «Настройках» и в «Истории платежей»: его можно открыть и скачать в PDF.': 'Sau khi thanh toán, hợp đồng được lưu trong «Cài đặt» và «Lịch sử thanh toán»: bạn có thể mở và tải về dạng PDF.',
    'После оплаты договоры сохранятся в «Настройках» и в «Истории платежей»: их можно открыть и скачать в PDF.': 'Sau khi thanh toán, các hợp đồng được lưu trong «Cài đặt» và «Lịch sử thanh toán»: bạn có thể mở và tải về dạng PDF.',
    'Договоры оказания услуг, которые вы подписали при оплате лицензий. Их можно открыть и скачать в любой момент.': 'Các hợp đồng dịch vụ bạn đã ký khi thanh toán giấy phép. Bạn có thể mở và tải về bất cứ lúc nào.',
    'от {date}, платёж № {payment}': 'ngày {date}, thanh toán số {payment}',
    'оплата возвращена': 'đã hoàn tiền',
    'Скачать PDF': 'Tải PDF',
    'Вы согласились с условиями договора и подписали его {date} в {time}, отметив «{label}».': 'Bạn đã đồng ý với các điều khoản của hợp đồng và ký vào {date} lúc {time} bằng cách đánh dấu «{label}».',
    'Не удалось получить договор. Попробуйте ещё раз.': 'Không tải được hợp đồng. Vui lòng thử lại.',

    // получение лицензий (правка начальника 02.10.2026)
    'Получение лицензий': 'Nhận giấy phép',
    'Можно оплатить': 'Có thể thanh toán',
    'Отметьте музеи и отправьте заявку.': 'Đánh dấu các bảo tàng và gửi yêu cầu.',
    'Дождитесь даты обучения — она появится здесь.': 'Chờ ngày đào tạo — ngày sẽ hiện ở đây.',
    'Выберите дату и оплатите обучение.': 'Chọn ngày và thanh toán khóa đào tạo.',
    'Приём заявок с {start} по {finish}': 'Nhận yêu cầu từ {start} đến {finish}',
    'Получение лицензий сейчас недоступно.': 'Hiện chưa thể nhận giấy phép.',
    'Мои заявки': 'Yêu cầu của tôi',
    'Новая заявка': 'Yêu cầu mới',
    'Стоимость обучения': 'Học phí đào tạo',
    'Приём заявок сейчас закрыт.': 'Hiện không nhận yêu cầu.',
    'Отправить заявку': 'Gửi yêu cầu',
    'Заявка отправлена: {museums}. Когда появится дата обучения, вы сможете выбрать её и оплатить.': 'Đã gửi yêu cầu: {museums}. Khi có ngày đào tạo, bạn có thể chọn ngày và thanh toán.',
    'Заявки отправлены: {museums}. Когда появится дата обучения, вы сможете выбрать её и оплатить.': 'Đã gửi các yêu cầu: {museums}. Khi có ngày đào tạo, bạn có thể chọn ngày và thanh toán.',
    'Заявка отправлена: {museums}. Дата обучения уже есть — выберите её в «Моих заявках» и оплатите.': 'Đã gửi yêu cầu: {museums}. Đã có ngày đào tạo — hãy chọn ngày trong «Yêu cầu của tôi» và thanh toán.',
    'Заявки отправлены: {museums}. Дата обучения уже есть — выберите её в «Моих заявках» и оплатите.': 'Đã gửi các yêu cầu: {museums}. Đã có ngày đào tạo — hãy chọn ngày trong «Yêu cầu của tôi» và thanh toán.',
    'Не удалось получить список заявок. Попробуйте ещё раз.': 'Không tải được danh sách yêu cầu. Vui lòng thử lại.',
    'Язык: {langs}': 'Ngôn ngữ: {langs}',
    'Языки: {langs}': 'Các ngôn ngữ: {langs}',
    'Заявка подана. Дата обучения пока не назначена. Когда она появится, вы сможете выбрать дату и оплатить обучение.': 'Đã gửi yêu cầu. Chưa có ngày đào tạo. Khi có ngày, bạn có thể chọn ngày và thanh toán khóa đào tạo.',
    'Заявка подана. Выберите дату обучения и оплатите.': 'Đã gửi yêu cầu. Hãy chọn ngày đào tạo và thanh toán.',
    'Заявка подана. Дата обучения: {group}.': 'Đã gửi yêu cầu. Ngày đào tạo: {group}.',
    'Заявка подана.': 'Đã gửi yêu cầu.',
    'Дата обучения': 'Ngày đào tạo',
    'Дата обучения: {group}': 'Ngày đào tạo: {group}',
    'Даты обучения': 'Các ngày đào tạo',
    'Оплата этого обучения производится в офисе. Для справок свяжитесь с менеджером по телефону {phone}.': 'Khóa đào tạo này được thanh toán tại văn phòng. Để biết thêm, hãy liên hệ quản lý theo số {phone}.',
    'Заявка подана. Стоимость обучения пока не указана — оплата откроется позже.': 'Đã gửi yêu cầu. Chưa có học phí đào tạo — việc thanh toán sẽ mở sau.',
    'Обучение оплачено. Записываем вас на {date}. Если запись не появится — позвоните менеджеру: {phone}.': 'Đã thanh toán khóa đào tạo. Chúng tôi đang ghi tên bạn vào ngày {date}. Nếu chưa thấy ghi nhận — hãy gọi quản lý: {phone}.',
    'Обучение оплачено.': 'Đã thanh toán khóa đào tạo.',
    'Обучение оплачено. Дату обучения сообщит менеджер.': 'Đã thanh toán khóa đào tạo. Quản lý sẽ thông báo ngày đào tạo.',
    'Записать вас на {date} не получилось: {reason}': 'Không ghi tên được cho bạn vào ngày {date}: {reason}',
    'Выберите другую дату.': 'Hãy chọn ngày khác.',
    'Дату обучения сообщит менеджер: {phone}.': 'Quản lý sẽ thông báo ngày đào tạo: {phone}.',
    'Обучение оплачено. Вы записаны: {group}.': 'Đã thanh toán khóa đào tạo. Bạn đã được ghi tên: {group}.',
    'Обучение пройдено.': 'Đã hoàn thành khóa đào tạo.',
    'Лицензия № {no}, действует до {date}.': 'Giấy phép số {no}, có hiệu lực đến {date}.',
    'Оплата на сайте пока недоступна. Свяжитесь с менеджером: {phone}.': 'Chưa thể thanh toán trên trang web. Hãy liên hệ quản lý: {phone}.',
    'Изменить языки или отменить заявку можно через менеджера: {phone}.': 'Để đổi ngôn ngữ hoặc hủy yêu cầu, hãy liên hệ quản lý: {phone}.',
    'Место в группе закрепляется после оплаты.': 'Chỗ trong nhóm được giữ sau khi thanh toán.',
    'Выбрать дату': 'Chọn ngày',
    'Оплата обучения': 'Thanh toán đào tạo',
    'Получаете лицензию впервые?': 'Bạn nhận giấy phép lần đầu?',
    'Вам в раздел «Получение лицензий»': 'Hãy vào mục «Nhận giấy phép»',
    'К заявкам': 'Về yêu cầu',
    'Обучение и дата': 'Đào tạo và ngày',
    'Музей и дата обучения': 'Bảo tàng và ngày đào tạo',
    'Музеи, по которым продлеваете лицензию': 'Các bảo tàng bạn gia hạn giấy phép',
    'Оплата обучения на сайте пока недоступна.': 'Chưa thể thanh toán đào tạo trên trang web.',
    'Оплачивать пока нечего. Оплата откроется после заявки, когда появится дата обучения.': 'Chưa có gì để thanh toán. Việc thanh toán sẽ mở sau khi gửi yêu cầu và có ngày đào tạo.',
    'Дата обучения ещё не назначена': 'Chưa có ngày đào tạo',
    'Выбранная дата обучения больше недоступна. Выберите дату заново.': 'Ngày đào tạo đã chọn không còn khả dụng. Vui lòng chọn lại ngày.',
    'Обучение оплачено. Запись на выбранную дату появится на странице «Получение лицензий».': 'Đã thanh toán khóa đào tạo. Việc ghi tên vào ngày đã chọn sẽ hiện trên trang «Nhận giấy phép».',
    'К моим заявкам': 'Về yêu cầu của tôi',
    'К оплате продления': 'Về thanh toán gia hạn',
    'Появилась дата обучения: {museums}. Можно выбрать дату и оплатить.': 'Đã có ngày đào tạo: {museums}. Bạn có thể chọn ngày và thanh toán.',
    'Обучение оплачено, выберите дату: {museums}.': 'Đã thanh toán khóa đào tạo, hãy chọn ngày: {museums}.',
    'Перейти': 'Mở',
    'Перейти к получению лицензии': 'Chuyển đến nhận giấy phép',
    'Не удалось получить список языков.': 'Không thể tải danh sách ngôn ngữ.',
    'Дата обучения прошла.': 'Ngày đào tạo đã qua.',
    'Лицензия по этому музею у вас уже есть. Обратитесь к менеджеру.': 'Bạn đã có giấy phép cho bảo tàng này. Vui lòng liên hệ với quản lý.',
    'Заявки отправлены: {museums}. Дата обучения уже есть: {dated} — выберите её в «Моих заявках» и оплатите.': 'Đã gửi các yêu cầu: {museums}. Đã có ngày đào tạo cho: {dated} — hãy chọn ngày trong «Yêu cầu của tôi» và thanh toán.',
    'Выберите дату обучения по каждому музею.': 'Hãy chọn ngày đào tạo cho từng bảo tàng.',
    'Система заявок сейчас не отвечает. Попробуйте через минуту.': 'Hệ thống yêu cầu hiện không phản hồi. Vui lòng thử lại sau một phút.',
    'Подтвердите договор оказания услуг.': 'Vui lòng xác nhận hợp đồng cung cấp dịch vụ.',
    'Лицензия не указана.': 'Chưa chỉ định giấy phép.',
    'Лицензия не найдена.': 'Không tìm thấy giấy phép.',
    'Выберите хотя бы одну лицензию.': 'Hãy chọn ít nhất một giấy phép.',
    'Введите ФИО кириллицей — допустимы только буквы, пробел и дефис.': 'Hãy nhập họ tên bằng chữ Kirin — chỉ được dùng chữ cái, dấu cách và dấu gạch nối.',
    'Не выбран музей.': 'Chưa chọn bảo tàng.',
    'Выберите язык: без него заявку на обучение не примут.': 'Hãy chọn ngôn ngữ: thiếu ngôn ngữ, yêu cầu đào tạo sẽ không được nhận.',
    'Так записаться можно только на первичное обучение.': 'Cách này chỉ dùng để đăng ký đào tạo lần đầu.',
    'Выбор даты откроется после оплаты обучения.': 'Chọn ngày sẽ mở sau khi thanh toán khóa đào tạo.',
    'Введите ФИО полностью.': 'Nhập đầy đủ họ tên.',
    'Введите корректный телефон.': 'Nhập số điện thoại hợp lệ.',
    'Введите корректный email.': 'Nhập email hợp lệ.',
    'Система заявок отклонила запрос. Попробуйте ещё раз или свяжитесь с оператором.': 'Hệ thống yêu cầu đã từ chối. Vui lòng thử lại hoặc liên hệ nhân viên.',
    'Первичное получение, продление': 'Cấp lần đầu, gia hạn',
    'Мои договоры': 'Hợp đồng của tôi',
    'Подписанных договоров пока нет. Они появятся здесь после оплаты продления или обучения на сайте.': 'Chưa có hợp đồng đã ký. Chúng sẽ xuất hiện ở đây sau khi bạn thanh toán gia hạn hoặc đào tạo trên trang web.',
    'Здесь можно заказать технические средства ведения экскурсий': 'Tại đây bạn có thể đặt thiết bị kỹ thuật phục vụ tham quan',

    // Прайс-лист с ценами (09.10.2026)
    'Ваши цены': 'Giá của bạn',
    'Персональный прайс-лист': 'Bảng giá cá nhân',
    'Общий прайс-лист': 'Bảng giá chung',
    'действует с': 'có hiệu lực từ',
    'Объект': 'Đối tượng',
    'Основная цена': 'Giá cơ bản',
    'Льготная цена': 'Giá ưu đãi',
    'Стоимость по прайс-листу:': 'Giá theo bảng giá:',
    'без учёта:': 'chưa gồm:',

    // Прайс-листы по категориям групп (12.10.2026)
    'Российские туристы': 'Du khách Nga',
    'Иностранные туристы': 'Du khách nước ngoài',
    'Китайские туристы': 'Du khách Trung Quốc',
    'Школьная группа': 'Đoàn học sinh',
    'Школьные группы': 'Các đoàn học sinh',
    'Основная': 'Cơ bản',
    'Льготная': 'Ưu đãi',
    'За группу': 'Theo đoàn',
    'Группа до {n} чел.': 'Đoàn tối đa {n} người',
    'Экскурсионное обслуживание': 'Dịch vụ hướng dẫn tham quan',
    'Обслуживание до {n} чел.': 'Dịch vụ, đoàn tối đa {n} người',
    'ЭО': 'HDV',
    'Экскурсионное обслуживание, за одно': 'Dịch vụ hướng dẫn tham quan, mỗi lượt',
    'экскурсионное обслуживание': 'dịch vụ hướng dẫn tham quan',
    'VIP': 'VIP',
    'за группу': 'mỗi đoàn',
    'Нажмите на заголовок, чтобы раскрыть цены, на название музея — его объекты': 'Nhấn vào tiêu đề để xem giá, vào tên bảo tàng để xem các đối tượng',
    'ШКОЛЬНАЯ': 'HỌC SINH',
    'Цена за группу': 'Giá theo nhóm',
    'до {n} чел.': 'tối đa {n} người',
    'Услуги в заявке в музей': 'Dịch vụ trong đơn tham quan bảo tàng',
    'за человека': 'mỗi người',
    'за доставку': 'mỗi lần giao hàng',
    'Калькулятор цен': 'Máy tính giá',
    'Выберите музей, объект и количество билетов — стоимость посчитается по вашему прайс-листу': 'Chọn bảo tàng, địa điểm và số lượng vé — chi phí sẽ được tính theo bảng giá của bạn',
    'Дата нужна, чтобы взять прайс-лист, действующий на день посещения': 'Ngày tham quan dùng để chọn bảng giá có hiệu lực vào ngày đó',
    'При группе от {n} человек требуется радиогид': 'Nhóm từ {n} người trở lên bắt buộc dùng radio guide',
    'Стоимость': 'Chi phí',
    'Выберите музей и объект — расчёт появится здесь': 'Chọn bảo tàng và địa điểm — kết quả tính sẽ hiện ở đây',
    'Укажите количество билетов': 'Nhập số lượng vé',
    'Считаем…': 'Đang tính…',
    'Для этого объекта цены в прайс-листе нет. Сумму рассчитает менеджер после подачи заявки.': 'Bảng giá không có giá cho địa điểm này. Quản lý sẽ tính số tiền sau khi đơn được gửi.',
    'Расчёт недоступен: войдите в кабинет заново': 'Không thể tính: vui lòng đăng nhập lại',
    'Итого': 'Tổng cộng',
    'У этих услуг нет цены в прайс-листе — её уточнит менеджер.': 'Các dịch vụ này chưa có giá trong bảng giá — quản lý sẽ xác nhận.',
    'Основные билеты': 'Vé giá thường',
    'Льготные билеты': 'Vé ưu đãi',
    '{n} чел.': '{n} người',
    'Хотите рассчитать цену?': 'Muốn tính giá?',
    'Воспользуйтесь нашим калькулятором: выберите музей, объект и количество билетов — сумма посчитается по вашему прайс-листу.': 'Hãy dùng máy tính của chúng tôi: chọn bảo tàng, địa điểm và số lượng vé — số tiền sẽ được tính theo bảng giá của bạn.',
    'Открыть калькулятор': 'Mở máy tính',
    'Изменить номер': 'Đổi số',
    'Изменить номер лицензии': 'Đổi số giấy phép',
    'Не удалось изменить номер лицензии. Попробуйте ещё раз.': 'Không thể đổi số giấy phép. Vui lòng thử lại.',
    'Расчёт по группам': 'Tính theo đoàn',
    'Музеев в расчёте': 'Bảo tàng trong tính toán',
    'Итого по всем группам': 'Tổng cộng tất cả các đoàn',
    'Очистить расчёт': 'Xoá tính toán',
    'Группа добавлена в расчёт. Выберите следующий музей — количество билетов подставится прежнее.': 'Đoàn đã được thêm vào tính toán. Chọn bảo tàng tiếp theo — số lượng vé sẽ được giữ nguyên.',
    'чел.': 'người',
    'Убрать': 'Bỏ',
    'Вместе с добавленными группами ({n})': 'Cùng với các đoàn đã thêm ({n})',
    'Расчёт стоимости': 'Tính toán chi phí',
    'Заголовок документа': 'Tiêu đề tài liệu',
    'Не удалось подготовить файл. Попробуйте ещё раз.': 'Không thể tạo tệp. Vui lòng thử lại.',
    'доставка': 'giao hàng',
    'Скачать расчёт': 'Tải bản tính',
    'новое': 'mới',
    'Подача заявок по расчёту': 'Gửi đơn theo bản tính',
    'На каждый музей уйдёт отдельная заявка. Выберите время посещения и укажите данные гида.': 'Mỗi bảo tàng sẽ nhận một đơn riêng. Chọn giờ tham quan và nhập thông tin hướng dẫn viên.',
    'На эту дату записи нет — измените дату в калькуляторе': 'Ngày này không có khung giờ — hãy đổi ngày trong máy tính',
    'выберите время': 'chọn giờ',
    'это время больше недоступно, выберите другое': 'giờ này không còn trống, hãy chọn giờ khác',
    'Отправлено заявок: {n}': 'Đã gửi đơn: {n}',
    'Причина': 'Lý do',
    'До сбоя в офис успели уйти заявки {list} — они уже в «Заказах», подавать их заново не нужно.': 'Các đơn {list} đã tới văn phòng trước sự cố — chúng đã có trong “Đơn hàng”, không cần gửi lại.',
    'Остальные музеи оставлены в расчёте — исправьте и отправьте заново.': 'Các bảo tàng còn lại vẫn trong bản tính — sửa và gửi lại.',
    'Успешно': 'Thành công',
    'Заявка не отправлена': 'Đơn chưa được gửi',
    'Заявка на эту дату не принимается: не раньше чем за {n} дн. — измените дату в калькуляторе': 'Không nhận đơn cho ngày này: phải trước ít nhất {n} ngày — hãy đổi ngày trong máy tính',

    // Калькулятор стоимости лицензий и выбор калькулятора (27.10.2026).
    'Билеты, экскурсионное обслуживание и услуги по вашему прайс-листу. Расчёт можно скачать и сразу подать заявку.': 'Vé, dịch vụ hướng dẫn và các dịch vụ theo bảng giá của bạn. Có thể tải bản tính và gửi yêu cầu ngay.',
    'Выберите, что посчитать': 'Chọn nội dung cần tính',
    'Из них оплачивается в офисе': 'Trong đó thanh toán tại văn phòng',
    'К выбору калькулятора': 'Quay lại chọn máy tính',
    'К получению лицензий': 'Đến mục nhận giấy phép',
    'Расчёт стоимости заявки': 'Tính chi phí yêu cầu',
    'Расчёт стоимости лицензий': 'Tính chi phí giấy phép',
    'Не удалось получить цены. Попробуйте ещё раз.': 'Không lấy được giá. Vui lòng thử lại.',
    'Оплачивается в офисе': 'Thanh toán tại văn phòng',
    'Отметьте музеи слева — здесь появится расчёт.': 'Đánh dấu các bảo tàng ở bên trái — bản tính sẽ hiện ở đây.',
    'Отметьте музеи — стоимость посчитается по ценам текущего сезона': 'Đánh dấu các bảo tàng — chi phí được tính theo giá mùa hiện tại',
    'Очистить': 'Xóa',
    'Первичное получение (обучение)': 'Nhận lần đầu (đào tạo)',
    'Продление и получение лицензий по ценам текущего сезона. Расчёт можно скачать и перейти к оплате.': 'Gia hạn và nhận giấy phép theo giá mùa hiện tại. Có thể tải bản tính và chuyển đến thanh toán.',
    'Продление лицензии': 'Gia hạn giấy phép',
    'Сезон': 'Mùa',
    'Цены на этот сезон пока не заведены. Уточните стоимость по телефону {phone}.': 'Giá cho mùa này chưa được thiết lập. Vui lòng hỏi chi phí qua điện thoại {phone}.',
    'лицензий: {n}': 'giấy phép: {n}',
    'Цены на сезон пока нет — уточните по телефону {phone}.': 'Chưa có giá cho mùa này — vui lòng hỏi qua điện thoại {phone}.',

    // Договор при отметке «Согласие» (28.10.2026).
    'Вы согласились с условиями договора и подписали его {date} в {time}, нажав «Согласие».': 'Bạn đã đồng ý với các điều khoản của hợp đồng và ký vào {date} lúc {time} bằng cách đánh dấu «Đồng ý».',
    'Договор подписан и сохранён в «Настройках».': 'Hợp đồng đã được ký và lưu trong «Cài đặt».',
    'Договоры оказания услуг, которые вы подписали отметкой «Согласие» при оплате лицензий. Их можно открыть и скачать в любой момент.': 'Các hợp đồng dịch vụ bạn đã ký bằng dấu «Đồng ý» khi thanh toán giấy phép. Có thể mở và tải xuống bất cứ lúc nào.',
    'Договоры подписаны и сохранены в «Настройках».': 'Các hợp đồng đã được ký và lưu trong «Cài đặt».',
    'Не удалось сохранить договор. Попробуйте ещё раз.': 'Không lưu được hợp đồng. Vui lòng thử lại.',
    'Подписанных договоров пока нет. Они появятся здесь, как только вы отметите «Согласие» на шаге оплаты продления или обучения.': 'Chưa có hợp đồng đã ký. Chúng sẽ xuất hiện ở đây ngay khi bạn đánh dấu «Đồng ý» ở bước thanh toán gia hạn hoặc đào tạo.',
    'После отметки «Согласие» договор сохранится в «Настройках»: его можно открыть и скачать в PDF в любой момент.': 'Sau khi đánh dấu «Đồng ý», hợp đồng được lưu trong «Cài đặt»: có thể mở và tải PDF bất cứ lúc nào.',
    'После отметки «Согласие» договоры сохранятся в «Настройках»: их можно открыть и скачать в PDF в любой момент.': 'Sau khi đánh dấu «Đồng ý», các hợp đồng được lưu trong «Cài đặt»: có thể mở và tải PDF bất cứ lúc nào.',
    'Согласие: я принимаю условия договора возмездного оказания услуг': 'Đồng ý: tôi chấp nhận các điều khoản của hợp đồng dịch vụ có thu phí',
    'Согласие: я принимаю условия договоров возмездного оказания услуг': 'Đồng ý: tôi chấp nhận các điều khoản của các hợp đồng dịch vụ có thu phí',
    'Сохраняем договор…': 'Đang lưu hợp đồng…',
    'ожидает оплаты': 'chờ thanh toán',
    'от {date}': 'ngày {date}',

    // Расчёт стоимости: радиогид/аудиогид, итоги в множественных заявках (30.10.2026)
    'Что считаем': 'Tính gì',
    'Заявка в музей': 'Đơn đặt bảo tàng',
    'Радиогид в город': 'Hướng dẫn vô tuyến trong thành phố',
    'Радиогид в музей': 'Hướng dẫn vô tuyến trong bảo tàng',
    'Выберите музей — расчёт появится здесь': 'Chọn bảo tàng — kết quả tính sẽ hiện ở đây',
    'Укажите количество аппаратов': 'Nhập số lượng thiết bị',
    'Для этой услуги цены в прайс-листе нет. Сумму рассчитает менеджер после подачи заказа.': 'Bảng giá không có giá cho dịch vụ này. Quản lý sẽ tính số tiền sau khi đặt hàng.',
    'Заказать радиогид / аудиогид': 'Đặt hướng dẫn vô tuyến / âm thanh',
    'В расчёте есть заказ радиогида или аудиогида: такие заказы подаются в разделе «Радиогид / Аудиогид», заявки в музеи — из расчёта без него.': 'Bản tính có đơn hướng dẫn vô tuyến hoặc âm thanh: các đơn này được đặt ở mục «Hướng dẫn vô tuyến / âm thanh», đơn bảo tàng gửi từ bản tính không có nó.',
    'Доставка': 'Giao hàng',
    'за пределами КАД': 'ngoài đường vành đai',
    'в пределах КАД': 'trong đường vành đai',
    'доставка в пределах КАД': 'giao hàng trong đường vành đai',
    'Аппараты': 'Thiết bị',
    'аппараты': 'thiết bị',
    'Заказ добавлен в расчёт.': 'Đơn đã được thêm vào bản tính.',
    'оценено музеев: {n} из {total}': 'đã tính giá: {n} trong {total} bảo tàng',
    'оценено групп: {n} из {total}': 'đã tính giá: {n} trong {total} nhóm',
    'Кол-во аппаратов': 'Số lượng thiết bị',
    'Оформить доставку (услуга платная)': 'Đặt giao hàng (dịch vụ trả phí)',
    'Доставка в пределах КАД': 'Giao hàng trong đường vành đai',
    'Доставка за пределы КАД': 'Giao hàng ngoài đường vành đai',
}
